import { useMemo } from 'react';
import { IconTag, StatusTagEnum, StyledSpinner, Tag, theme } from '@tryhackme/thm-ui-components';
import { ToolTip } from 'src/common/components';
import { formatTime } from 'src/common/date';
import { useJoinLabMutation, useLeaveLabMutation } from 'src/features/api/rooms/azure/azure.slice';
import { StyledAzureEnvironment, StyledEnvStateAndTag, StyledPillLabel, StylesEnvStateText } from '../azure-cloud-details-modal.styles';
import { AzureSectionProps } from '../azure-cloud-details-modal.types';
export const AzureEnvironment = ({
  lab,
  formattedExpiry
}: AzureSectionProps) => {
  const [, {
    isLoading: isJoining
  }] = useJoinLabMutation({
    fixedCacheKey: 'join-azure-lab'
  });
  const [, {
    isLoading: isLeaving
  }] = useLeaveLabMutation({
    fixedCacheKey: 'leave-azure-lab'
  });
  const updating = isJoining || isLeaving;
  const labState: {
    label: string;
    colour: StatusTagEnum;
  } = useMemo(() => {
    if (lab) {
      if (lab.isExpired || formattedExpiry === null) {
        return {
          label: 'Expired',
          colour: StatusTagEnum.RED
        };
      }
      return {
        label: `Joined`,
        colour: StatusTagEnum.GREEN
      };
    }
    return {
      label: 'Not Joined',
      colour: StatusTagEnum.ORANGE
    };
  }, [lab, formattedExpiry]);
  return <StyledAzureEnvironment data-sentry-element="StyledAzureEnvironment" data-sentry-component="AzureEnvironment" data-sentry-source-file="azure-environment.tsx">
      <StyledEnvStateAndTag data-sentry-element="StyledEnvStateAndTag" data-sentry-source-file="azure-environment.tsx">
        <StylesEnvStateText data-sentry-element="StylesEnvStateText" data-sentry-source-file="azure-environment.tsx">Lab State:</StylesEnvStateText>

        {updating ? <IconTag>
            <StyledPillLabel>
              <StyledSpinner color={theme.colors.icon.main} />
            </StyledPillLabel>
          </IconTag> : <Tag size="default" status={labState.colour} data-testid="status-tag">
            <StyledPillLabel>{labState.label}</StyledPillLabel>
          </Tag>}
      </StyledEnvStateAndTag>
      {lab?.expires && formattedExpiry !== null && <StyledEnvStateAndTag>
          <StylesEnvStateText>Expires in:</StylesEnvStateText>

          <Tag size="default" status={StatusTagEnum.BLUE} data-testid="status-tag">
            <ToolTip side="bottom" toolTipText={`Expires at ${formatTime(lab?.expires)}`}>
              <StyledPillLabel>{formattedExpiry}</StyledPillLabel>
            </ToolTip>
          </Tag>
        </StyledEnvStateAndTag>}
    </StyledAzureEnvironment>;
};